import BaseUser from "@/project/model/base/BaseUser";

export default class ReservoirModel extends BaseUser {

    id = 0;
    code = '';
    warehouseId = 0;
    name = '';
    remark = '';
    warehouseName = '';

}